import React, { useContext } from "react";
import { LoginContext } from "../LoginView";
import LoginLogo from "../../../assets/images/clsm-logo.svg";
import { loginMfa } from "../../../api/Api";

import "./loginPage.css";
import ThemeInput from "../../../components/ThemeInput/ThemeInput";
import ThemeButton from "../../../components/ThemeButton/ThemeButton";
import EyeOpen from "../../../assets/images/icons/password-show.svg";
import EyeClose from "../../../assets/images/icons/password-hide.svg";
import Loader from "../../../components/Loader/Loader";
import PopupAlertError from "../../../components/PopupAlertError/PopupAlertError";
import { BorderAll } from "@mui/icons-material";
import MfaPopup from "../../../components/MfaPopup/MfaPopup";
import routeContstants from "../../../constants/routeConstants.json";
import { useNavigate } from "react-router";
import ErrorPopup from "../../../components/PopupAlertError/PopupAlertError";
import SuccessPopupAlert from "../../../components/PopupAlertSuccess/PopupAlert";

const LoginPage = () => {
  const {
    passwordType,
    toggleEyeIcon,
    pageContent,
    spinnerStatus,
    emailValidationMsg,
    email,
    errorAlertMessage,
    errorAlertShow,
    setErrorAlertMessage,
    setErrorAlertShow,
    submitLogin,
    statusCode,
    password,
    handleEmailChange,
    handlePasswordChange,
    passwordValidateMsg,
    navigatePage,
    mfaPop,
    setMfaPop,
    enteredCode,
    setEnteredCode,
    mfaType,
    userId,
    submitPopupData,
    emailValidation,
    onClickReSend,
    errorPopup,
    errorPopupMessage,
    buttonText,
    statusValue,
    setErrorPopup,
    errorPopupTrigger,
    permissionUpdatePopup,
    handleSuccessPopup
  } = useContext(LoginContext);

  const navigate = useNavigate();

  return (
    // main div starts

    <div className="loginPage">
      {spinnerStatus && <Loader />}
      <div className="loginLogo">
        <div className="loginLeft"></div>
      </div>
      <div className="loginEnter loginContainer">
        <div className="flexContentData">
          <h3>
            <img src={LoginLogo} alt="logo" />
          </h3>

          <p className="mb-2 formSubTitle">{pageContent.pageTitle}</p>
          <p className="mb-3 subTitleLogin">{pageContent.subPageTitle}</p>
          <form onSubmit={submitLogin}>
            {/* Email Input starts*/}
            <label className="input-label mt-4 mb-1">
              {pageContent.emailLabel}
            </label>
            <ThemeInput
              onBlur={() => emailValidation(email)}
              placeholder={pageContent.emailPlaceholder}
              value={email}
              onChange={handleEmailChange}
              className={`${emailValidationMsg ? "loginInputRedBorder" : ""}`}
            />
            <p className="mb-0 error-msg">
              {emailValidationMsg ? emailValidationMsg : ""}
            </p>
            <label className="input-label mt-3 mb-1">
              {pageContent.passwordLabel}
            </label>
            <div className="icon-input">
              <ThemeInput
                placeholder={pageContent.passwordPlaceholder}
                type={passwordType}
                value={password}
                onChange={handlePasswordChange}
                className={`${
                  passwordValidateMsg ? "loginInputRedBorder" : ""
                }`}
              />
              <span className="eye-icon" onClick={toggleEyeIcon}>
                {passwordType === "password" ? (
                  <img src={EyeOpen} alt="Eye-open" />
                ) : (
                  <img src={EyeClose} alt="Eye-close" />
                )}
              </span>
            </div>
            <p className="mb-0 error-msg">
              {passwordValidateMsg ? passwordValidateMsg : ""}
            </p>
            {/* password input ends */}

            {/* forgot password div starts */}
            <div className="password-wrap">
              <div className="rememberme-text mt-3">
                {/*pageContent.rememberMe*/}
              </div>
              <div
                className="forgot-password-txt text-end mt-3"
                onClick={navigatePage}
              >
                {pageContent.forgotPassword}
              </div>
            </div>
            {/* forgot password div ends */}

            {/* submit button */}
            <ThemeButton
              value={pageContent.loginButtonText}
              id="loginSubmitbtns"
              className="mt-5"
              type="submit"
            />
          </form>
        </div>
      </div>

      <MfaPopup
        show={mfaPop}
        setShow={setMfaPop}
        alertMessage={
          mfaType === "Email"
            ? pageContent.emailMessageMFA
            : mfaType === "App"
            ? pageContent?.appMessageMFA
            : ""
        }
        handleSubmitData={submitPopupData}
        modalTitle={"Enter Code"}
        handleCancelClick={() => {
          setMfaPop(false);
        }}
        buttonSubmitText={"Verify"}
        onClickReSend={onClickReSend}
        code={enteredCode}
        setCode={setEnteredCode}
        mfaType={mfaType}
      />

      <ErrorPopup
        // show={errorPopup}
        show={errorAlertShow}
        alertMessage={errorAlertMessage}
        buttonText={buttonText}
        status={statusValue}
        handleCancel={() => setErrorAlertShow(false)}
        handleSubmit={() => {
          if (statusValue === 401 || statusValue === 403) {
            // goToLogin();
            setErrorAlertShow(false);
          } else {
            setErrorAlertShow(false);
            // getUserDetails();
          }
        }}
      />
            <SuccessPopupAlert
        show={permissionUpdatePopup}
        alertMessage={"Your permission has been updated"}
        handleSubmit={() => handleSuccessPopup()}
      />
      <ErrorPopup
        // show={errorPopup}
        show={errorAlertShow}
        alertMessage={errorAlertMessage}
        buttonText={buttonText}
        status={statusValue}
        handleCancel={() => setErrorAlertShow(false)}
        handleSubmit={() => {
          if (statusValue === 401 || statusValue === 403) {
            // goToLogin();
            setErrorAlertShow(false);
          } else {
            setErrorAlertShow(false);
            if (errorPopupTrigger === "submitPopupData") {
              submitPopupData();
            } else if (errorPopupTrigger === "submitLogin") {
              document.getElementById("loginSubmitbtns").click();
            }
          }
        }}
      />
    </div>

    // main div end
  );
};

export default LoginPage;
